import EntityServise from "./entityService";

class JobService extends EntityServise {

    constructor() {
        super("job")
    }

    async insertSolic(solic) {
        return await this.http.post(this.routeApi + "/solic", solic)
    }

    async updateStatus(jobId, previousJobId, nextStatus, last) {
        return this.http.post(this.routeApi + '/update-status', null,
            { id: jobId, previousJobId, status: nextStatus, last }
        )
    }
    async getKanban(environmentId, accountId, resourceId, itemId, searchFields, search, page, limit) {
        return await this.http.get(this.routeApi + "/kanban", { environmentId, accountId, resourceId, itemId, searchFields, search, page, limit })
    }

    async getKanbanByGroup(environmentId, accountId, resourceId, itemId, searchFields, search, page, limit) {
        return await this.http.get(this.routeApi + "/kanban-group", { environmentId, accountId, resourceId, itemId, searchFields, search, page, limit })
    }

    async getTotalsKanban(environmentId,accountId,resourceId,itemId,searchFields,search) {
        return await this.http.get(this.routeApi + "/kanban-status-total", { environmentId ,accountId,resourceId,itemId,searchFields,search})
    }
}

export default new JobService()